import { MutationFunctionOptions } from '@apollo/client'

export type FilterValue = any

export const BUILT_IN_FILTER_TYPES = {
  COMPANY: 'company',
  USER: 'user',
  LOCATION: 'location',
  EQUIPMENT: 'equipment',
  WORKFLOW_CATEGORY: 'workflow_category',
  WORKFLOW_TYPE: 'workflow_type',
  WORKFLOW_STATUS: 'workflow_status',
  PROJECT: 'project',
  FILE_TYPE: 'file_type',
  FILE_EXTENSION: 'file_extension',
} as const

export interface FilterTypeDescriptor {
  key: string
  label: string
  type?: string
  renderFilterValue?: (value: FilterValue) => JSX.Element | null
}

interface SavedViewFilterInput {
  id?: string
  name: string
  isPublic: boolean
  projectId: string
  userId?: string
  filtersByFilterType?: Array<{
    type?: string | null
    values?: Array<string | null> | null
  } | null> | null
  groupBy?: string | null
  defaultForUsers?: Array<string | null> | null
}

interface SavedViewFilterResult {
  id: string
  name: string
  isPublic: boolean
  filtersByFilterType?: Array<{
    type?: string | null
    values?: Array<string | null> | null
  } | null> | null
  groupBy?: string | null
  userId?: string
}

export type SaveFilterMutationFn = (
  options: MutationFunctionOptions<
    { [key: string]: SavedViewFilterResult | null },
    { filter: SavedViewFilterInput }
  >,
) => Promise<any>

export type DeleteFilterMutationFn = (
  options: MutationFunctionOptions<
    { [key: string]: boolean | null },
    { filterId: string }
  >,
) => Promise<any>
